import { createSelector } from 'reselect';

import { IMenuByTypesItem, TMenuKey as TMenuKeyFromResponse } from '@r1-frontend/api-domru/api-content/v2/menu/by-types';
import { TAuthorisationDependentMenuKey, TState } from '@r1-frontend/entities/stores/city/reducer';

type THeaderMenuKey = Exclude<TMenuKeyFromResponse, 'WebUnderMenu'>;

export type IHeaderMenuItems = Record<THeaderMenuKey, IMenuByTypesItem[]>

export const selectNewMenuItems = (state: TState) => state.city.newMenuItems;
const selectPartners = createSelector(selectNewMenuItems, menuItems => menuItems?.partners || []);
const selectService = createSelector(selectNewMenuItems, menuItems => menuItems?.service || []);
export const selectWebUnderMenu = createSelector(selectNewMenuItems, menuItems => menuItems?.WebUnderMenu || []);

export const selectHasMenu = createSelector(selectNewMenuItems, menuItems => !!menuItems);

const selectMenuItems = (menuKey: TAuthorisationDependentMenuKey) => createSelector(
    selectNewMenuItems,
    selectPartners,
    selectService,
    (menuItems, partners, service): IHeaderMenuItems => {
        return {
            main: menuItems ? menuItems[menuKey] ?? [] : [],
            partners,
            service,
        };
    },
);

export const selectAuthMenu = selectMenuItems('authMain');

export const selectUnauthMenu = selectMenuItems('unauthMain');
